import { ContentPill } from './ContentPill'
import { FaPlusCircle, FaMinusCircle } from 'react-icons/fa'
import theme from '@root/styles/theme'
import { useTranslation } from 'react-i18next'
import { IAuditTrailObjectBase, IChangeDocument } from '@root/query/auditTrail'
import { useBusinessContext } from '@root/context'
import styled from 'styled-components'
import { ITag } from '@root/query/tags'
import { TagPill } from '@root/components/TagPill/TagPill'
import { getSettingsPageUrl } from '@root/constants'
import { Link } from 'react-router-dom'

interface Props {
  auditRecord: IAuditTrailObjectBase<IChangeDocument>
}

export const TagBlock: React.FC<Props> = ({ auditRecord }) => {
  const [t] = useTranslation()
  const { slug } = useBusinessContext()

  const isAdded = auditRecord.changes?.[0]?.added.length !== 0

  const fileIcon = isAdded ? (
    <FaPlusCircle style={{ color: theme.colors.success }} />
  ) : (
    <FaMinusCircle style={{ color: theme.colors.error }} />
  )

  const tags = isAdded ? auditRecord.changes?.[0]?.added : auditRecord.changes?.[0]?.removed

  return (
    <TagsContainer>
      {tags.map((tag: ITag, index: number) => {
        return tag === null ? (
          <ContentPill
            key={`${index}-no-tag-found`}
            Icon={fileIcon}
            text={t('components.auditTrail.noTagFound')}
            info={t('components.auditTrail.noTagFoundInfo')}
          />
        ) : (
          <Link
            to={getSettingsPageUrl(slug, {
              page: 'tags'
            })}
            style={{ textDecoration: 'none', maxWidth: 'fit-content' }}
            key={`content-pill-${index}`}
          >
            <TagPill tag={tag} isRemoved={!isAdded} />
          </Link>
        )
      })}
    </TagsContainer>
  )
}

const TagsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}rem;
`
